/**
 * Frontend service for the location-management Medplum Bot.
 *
 * The Bot must be registered in Medplum with:
 *   identifier: { system: 'https://unify.health/bots', value: 'location-management' }
 *   runtimeVersion: 'vmcontext'
 */

import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { Identifier } from '@medplum/fhirtypes';

const LOCATION_MANAGEMENT_BOT_IDENTIFIER: Identifier = {
  system: 'https://unify.health/bots',
  value: 'location-management',
};

function getBotTarget(): string | Identifier {
  const id = import.meta.env.VITE_MEDPLUM_LOCATION_MANAGEMENT_BOT_ID?.trim();
  if (id) return id;
  return LOCATION_MANAGEMENT_BOT_IDENTIFIER;
}

export async function deleteRoom(
  medplum: MedplumClient,
  roomId: string,
): Promise<{ success: true; deletedId: string; reassignedDevices: string[] }> {
  return medplum.executeBot(
    getBotTarget(),
    { action: 'delete-room', roomId },
    ContentType.JSON,
  ) as Promise<{ success: true; deletedId: string; reassignedDevices: string[] }>;
}

export async function deleteEquipment(
  medplum: MedplumClient,
  equipmentId: string,
): Promise<{ success: true; deletedId: string }> {
  return medplum.executeBot(
    getBotTarget(),
    { action: 'delete-equipment', equipmentId },
    ContentType.JSON,
  ) as Promise<{ success: true; deletedId: string }>;
}

export async function deleteSite(
  medplum: MedplumClient,
  siteId: string,
): Promise<{ success: true; deletedId: string; deletedRooms: string[]; deletedDevices: string[] }> {
  return medplum.executeBot(
    getBotTarget(),
    { action: 'delete-site', siteId },
    ContentType.JSON,
  ) as Promise<{ success: true; deletedId: string; deletedRooms: string[]; deletedDevices: string[] }>;
}
